import {CLIENT_COMP_VERSION} from "../version";

export function Logger(klass: string, instanceId?: any) {
  const timestamp = function() {}
  timestamp.toString = function() {
    return new Date().toISOString()
  }

  let s = `${klass}(${CLIENT_COMP_VERSION}`;
  s += ( instanceId ) ? `/${instanceId})` : ')';
  return {
    debug: console.debug.bind(console, '%s', timestamp, s),
    info: console.info.bind(console, '%s', timestamp, s),
    warn: console.warn.bind(console, '%s', timestamp, s),
    error: console.error.bind(console, '%s', timestamp, s)
  }
}
